<template>
  <div class="container mt-5">
    <p class="subtitle is-4">Sorry, we can't find the page you were looking for!</p>
  </div>
</template>

<script>
export default {
  name: "NotFoundPage"
}
</script>

<style scoped>

</style>
